export const mailStructure = (contenido, adjuntos) => {
    const mailData = contenido
    if(adjuntos) mailData.attachments = adjuntos
    return mailData
};
